<template>
	<div class="userLeft">
		<div class="lbgbox" :style="userType==2?'height: calc(100% - 8.9rem)':'height: calc(100% - 7.9rem)'">
			<el-image class="lbg" :src="require('@/static/icon45.png')"></el-image>
		</div>
		<!-- logo -->
		<div class="logoBox" :style="selIdx==1?'border-radius: 0 0 0.2rem 0;':''">
			<el-image :src="require('@/static/icon2.png')"></el-image>
		</div>
		<!-- 选项nav -->
		<div class="selItm" @click="selIdx=1,link('/userHome')" :class="selIdx==1?'a':''" :style="pdyuanjiao(1)">
			<div class="tit f-ct">
				<el-image class="i1" :src="require('@/static/icon36h.png')"></el-image>
				<el-image class="i2" :src="require('@/static/icon36.png')"></el-image>
				<p>账户总览</p>
			</div>
		</div>
		<div class="selItm" @click="selIdx=2,link('/userCourse')" :class="selIdx==2?'a':''" :style="pdyuanjiao(2)">
			<div class="tit f-ct">
				<el-image class="i1" :src="require('@/static/icon37h.png')"></el-image>
				<el-image class="i2" :src="require('@/static/icon37.png')"></el-image>
				<p>课程中心</p>
			</div>
		</div>
		
		<!-- 普通 -->
		<template v-if="userType==1">
			<div class="selItm" @click="selIdx=3,link('/userOrder')" :class="selIdx==3?'a':''" :style="pdyuanjiao(3)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon38h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon38.png')"></el-image>
					<p>订单管理</p>
				</div>
			</div>
			<div class="selItm noafter" @click="selIdx=4,selIdx1=1,link('/classList')" :class="selIdx==4?'a':''" :style="pdyuanjiao(4)">
				<div class="tit f-bct">
					<div class="f-ct">
						<el-image class="i1" :src="require('@/static/icon39h.png')"></el-image>
						<el-image class="i2" :src="require('@/static/icon39.png')"></el-image>
						<p>培训管理</p>
					</div>
					<el-image class="i3" v-if="selIdx==4" :src="require('@/static/icon44.png')"></el-image>
					<el-image class="i3" v-else :src="require('@/static/icon43.png')"></el-image>
				</div>
				<div class="citmBox" v-if="selIdx==4">
					<div class="citm" @click.stop="selIdx1=1,link('/classList')" :class="selIdx1==1?'acitm':''">
						<div class="bor"></div>
						<p>学习中心</p>
					</div>
					<div class="citm" @click.stop="selIdx1=2,link('/examList')" :class="selIdx1==2?'acitm':''">
						<div class="bor"></div>
						<p>我的考试</p>
					</div>
				</div>
			</div>
			<div class="selItm" @click="selIdx=5,link('/userMsg')" :class="selIdx==5?'a':''" :style="pdyuanjiao(5)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon40h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon40.png')"></el-image>
					<p>学员信息</p>
				</div>
			</div>
			<div class="selItm" @click="selIdx=6,link('/fapiaoList')" :class="selIdx==6?'a':''" :style="pdyuanjiao(6)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon41h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon41.png')"></el-image>
					<p>发票管理</p>
				</div>
			</div>
			<div class="selItm"  @click="loginOut()" :style="pdyuanjiao(7)">
				<div class="tit f-ct">
					<el-image :src="require('@/static/icon42.png')"></el-image>
					<p>退出系统</p>
				</div>
			</div>
		</template>
		
		
		
		
		<!-- 企业 -->
		<template v-if="userType==2">
			<div class="selItm" @click="selIdx=3,link('/qyClass')" :class="selIdx==3?'a':''" :style="pdyuanjiao(3)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon38h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon38.png')"></el-image>
					<p>课程管理</p>
				</div>
			</div>
			<div class="selItm" @click="selIdx=4,link('/qyTrain')" :class="selIdx==4?'a':''" :style="pdyuanjiao(4)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon39h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon39.png')"></el-image>
					<p>培训记录</p>
				</div>
			</div>
			<div class="selItm" @click="selIdx=5,link('/userOrderQY')" :class="selIdx==5?'a':''" :style="pdyuanjiao(5)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon98h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon98.png')"></el-image>
					<p>订单管理</p>
				</div>
			</div>
			<div class="selItm" @click="selIdx=6,link('/qyStaff')" :class="selIdx==6?'a':''" :style="pdyuanjiao(6)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon99h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon99.png')"></el-image>
					<p>员工管理</p>
				</div>
			</div>
			<div class="selItm" @click="selIdx=7,link('/qyInfo')" :class="selIdx==7?'a':''" :style="pdyuanjiao(7)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon100h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon100.png')"></el-image>
					<p>企业信息</p>
				</div>
			</div>
			<div class="selItm" @click="selIdx=8,link('/fapiaoList')" :class="selIdx==8?'a':''" :style="pdyuanjiao(8)">
				<div class="tit f-ct">
					<el-image class="i1" :src="require('@/static/icon41h.png')"></el-image>
					<el-image class="i2" :src="require('@/static/icon41.png')"></el-image>
					<p>发票管理</p>
				</div>
			</div>
			<div class="selItm" @click="loginOut()" :style="pdyuanjiao(9)">
				<div class="tit f-ct">
					<el-image :src="require('@/static/icon42.png')"></el-image>
					<p>退出系统</p>
				</div>
			</div>
		</template>
		
		
		
		<!-- 退出登录 -->
		<div class="maskBg" @click="hblout=false" v-if="hblout"></div>
		<div class="subTipsQx" v-if="hblout">
			<el-image class="cha" @click="hblout=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon102.png')"></el-image>
			<div class="t1">确定要退出登录吗？</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="loginOutF">确定退出</div>
				<div class="b2" @click="hblout=false">我再想想</div>
			</div>
		</div>
		
		
		<div class="diandi"></div>
		<!--  -->
	</div>
</template>
<script>
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	name: "Head",
	data(){
		return {
			hblout:false,
			selIdx:1,
			selIdx1:1,
			pageHistory:[],
			// isqy:true,
		}
	},
	watch: {
		'$route': function(n,o) {
			// console.log('n',n.path)
			// console.log('o',o.path)
			if (localStorage.getItem('pageHistory')) {
				var arr = localStorage.getItem('pageHistory')
				arr = JSON.parse(arr)
				this.pageHistory = arr
			}
			if(
			n.path=='/userHome'||
			n.path=='/userCourse'||
			n.path=='/userOrder'||
			n.path=='/userOrderQY'||
			n.path=='/classList'||
			n.path=='/examList'||
			n.path=='/userMsg'||
			n.path=='/fapiaoList'||
			n.path=='/qyTrain'||
			n.path=='/qyStaff'||
			n.path=='/qyInfo'||
			n.path=='/qyClass'
			){
				this.pageHistory = []
			}
			if(this.pageHistory.length){
				if(n.path!=this.pageHistory[this.pageHistory.length-1]){
					this.pageHistory.push(n.path)
				}
			}else{
				this.pageHistory.push(n.path)
			}
			localStorage.setItem("pageHistory", JSON.stringify(this.pageHistory));
			// console.log(this.pageHistory)
			
			
			if(this.userType==1){
				if(this.pageHistory[0]=='/userHome'){
					this.selIdx = 1
				}
				
				if(this.pageHistory[0]=='/userCourse'){
					this.selIdx = 2
				}
				
				if(this.pageHistory[0]=='/userOrder'){
					this.selIdx = 3
				}
				
				if(this.pageHistory[0]=='/classList'){
					this.selIdx = 4
					this.selIdx1 = 1
				}
				
				if(this.pageHistory[0]=='/examList'){
					this.selIdx = 4
					this.selIdx1 = 2
				}
				
				if(this.pageHistory[0]=='/userMsg'){
					this.selIdx = 5
				}
				
				if(this.pageHistory[0]=='/fapiaoList'){
					this.selIdx = 6
				}
			}
			
			
			
			// 企业
			if(this.userType==2){
				if(this.pageHistory[0]=='/userHome'){
					this.selIdx = 1
				}
				if(this.pageHistory[0]=='/userCourse'){
					this.selIdx = 2
				}
				if(this.pageHistory[0]=='/qyClass'){
					this.selIdx = 3
				}
				if(this.pageHistory[0]=='/qyTrain'){
					this.selIdx = 4
				}
				if(this.pageHistory[0]=='/userOrderQY'){
					this.selIdx = 5
				}
				if(this.pageHistory[0]=='/qyStaff'){
					this.selIdx = 6
				}
				if(this.pageHistory[0]=='/qyInfo'){
					this.selIdx = 7
				}
				if(this.pageHistory[0]=='/fapiaoList'){
					this.selIdx = 8
				}
			}
			
		}
	},
	mounted() {
		// 获取 页面 浏览历史
		// console.log(localStorage.getItem('pageHistory'))
		if (localStorage.getItem('pageHistory')) {
			var arr = localStorage.getItem('pageHistory')
			arr = JSON.parse(arr)
			this.pageHistory = arr
		}
		if(
		this.$route.path=='/userHome'||
		this.$route.path=='/userCourse'||
		this.$route.path=='/userOrder'||
		this.$route.path=='/userOrderQY'||
		this.$route.path=='/classList'||
		this.$route.path=='/examList'||
		this.$route.path=='/userMsg'||
		this.$route.path=='/fapiaoList'||
		this.$route.path=='/qyTrain'||
		this.$route.path=='/qyStaff'||
		this.$route.path=='/qyInfo'||
		this.$route.path=='/qyClass'
		){
			this.pageHistory = []
		}
		if(this.pageHistory.length){
			if(this.$route.path!=this.pageHistory[this.pageHistory.length-1]){
				this.pageHistory.push(this.$route.path)
			}
		}else{
			this.pageHistory.push(this.$route.path)
		}
		localStorage.setItem("pageHistory", JSON.stringify(this.pageHistory));
		// console.log(this.pageHistory)
		
		
		
		
		if(this.userType==1){
			if(this.pageHistory[0]=='/userHome'){
				this.selIdx = 1
			}
			
			if(this.pageHistory[0]=='/userCourse'){
				this.selIdx = 2
			}
			
			if(this.pageHistory[0]=='/userOrder'){
				this.selIdx = 3
			}
			
			if(this.pageHistory[0]=='/classList'){
				this.selIdx = 4
				this.selIdx1 = 1
			}
			
			if(this.pageHistory[0]=='/examList'){
				this.selIdx = 4
				this.selIdx1 = 2
			}
			
			if(this.pageHistory[0]=='/userMsg'){
				this.selIdx = 5
			}
			
			if(this.pageHistory[0]=='/fapiaoList'){
				this.selIdx = 6
			}
		}
		
		
		
		// 企业
		if(this.userType==2){
			if(this.pageHistory[0]=='/userHome'){
				this.selIdx = 1
			}
			if(this.pageHistory[0]=='/userCourse'){
				this.selIdx = 2
			}
			if(this.pageHistory[0]=='/qyClass'){
				this.selIdx = 3
			}
			if(this.pageHistory[0]=='/qyTrain'){
				this.selIdx = 4
			}
			if(this.pageHistory[0]=='/userOrderQY'){
				this.selIdx = 5
			}
			if(this.pageHistory[0]=='/qyStaff'){
				this.selIdx = 6
			}
			if(this.pageHistory[0]=='/qyInfo'){
				this.selIdx = 7
			}
			if(this.pageHistory[0]=='/fapiaoList'){
				this.selIdx = 8
			}
		}
		
		
	},
	methods:{
		// 判断圆脚
		pdyuanjiao(index){
			if(this.selIdx==(index+1)){
				return 'border-radius: 0 0 0.2rem 0;'
			}
			if(this.selIdx==(index-1)){
				return 'border-radius: 0 0.2rem 0 0;'
			}
		},
		// 退出登录
		loginOut(){
			this.hblout = true
		},
		loginOutF(){
			this.Tips('操作成功','success')
			this.$store.commit('userMsg/tokenC','');
			this.$store.commit('userMsg/userInfoC','');
			this.$store.commit('userMsg/userTypeC',1);
			localStorage.clear();
			setTimeout(()=>{
				this.link('/home')
			},1500)
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.userLeft{
	width: 100%;
	height: 100%;
	position: relative;
	background: #f6f7fb;
	.lbg{
		position: absolute;
		bottom: 0;
		left: 0;
		height: 431px;
		width: 100%;
		z-index: 3;
	}
	.lbgbox{
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		background: #3B6492;
		z-index: 2;
	}
	.diandi{
		height: 390px;
		background: #3B6492;
	}
	.logoBox{
		width: 100%;
		height: 200px;
		background: #3B6492;
		padding-top: 15px;
		.el-image{
			width: 166px;
			height: 166px;
			display: block;
			margin: auto;
		}
	}
	.a{
		background: #f6f7fb!important;
		transition:0.1s;
		.tit{
			p{
				color: #3B6492!important;
			}
			.i1{
				display: block!important;
			}
			.i2{
				display: none!important;
			}
		}
	}
	.noafter{
		&::after{
			display: none;
		}
	}
	.selItm{
		width: 100%;
		// height: 70px;
		// padding: 20px 0;
		padding-left: 20px;
		background: #3B6492;
		position: relative;
		transition:0.1s;
		cursor: pointer;
		&::after{
			content: '';
			position: absolute;
			width: 2px;
			height: 18px;
			background: #3B6492;
			top: 50%;
			transform: translateY(-50%);
			right: 0;
		}
		.tit{
			height: 70px;
			.el-image{
				width: 30px;
				height: 30px;
				margin-right: 12px;
			}
			.i1{
				display: none;
			}
			.i2{
				display: block;
			}
			.i3{
				width: 20px;
				height: 20px;
			}
			p{
				font-size: 16px;
				font-weight: bold;
				color: #fff;
			}
		}
		.citmBox{
			.citm{
				padding-left: 15px;
				padding-bottom: 20px;
				display: flex;
				align-items: center;
				.bor{
					width: 10px;
					height: 4px;
					background: #777A82;
					margin-right: 17px;
				}
				p{
					font-size: 16px;
					color: #777A82;
				}
				&::after{
					content: '';
					position: absolute;
					width: 2px;
					height: 0px;
					background: #3B6492;
					top: 30%;
					transform: translateY(-50%);
					right: 0;
					// display: none;
					transition:0.3s;
				}
			}
			.acitm{
				&::after{
					// display: block;
					height: 18px;
					transition:0.3s;
				}
				.bor{
					background: #3B6492!important;
				}
				p{
					color: #3B6492!important;
				}
			}
		}
	}
}

.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTipsQx{
	position: fixed;
	width: 420px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 90px;
		height: 90px;
	}
	.icon1{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.t3{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 10px;
	}
	.t1{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 25px;
	}
	.t2{
		font-size: 14px;
		color: #7D7D89;
		padding: 0 26px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 120px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>